import { NgModule } from '@angular/core';
import { CustomComponentsModule } from './components/custom-components.module';
import { PRIMENGModule } from './prime-ng/prime-ng.module';
import { PipeModule } from './pipes/pipe.module';
import { TranslationModule } from '../core/services/i18n/translation.module';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LucideAngularModule } from 'lucide-angular';
import { LUCIDE_ICONS } from './lucide-icons';

@NgModule({
  declarations: [],
  imports: [
    CustomComponentsModule,
    PRIMENGModule,
    PipeModule,
    TranslationModule,
    TranslateModule,
    DynamicDialogModule,
    LucideAngularModule.pick(LUCIDE_ICONS),
  ],
  exports: [
    PRIMENGModule,
    PipeModule,
    CustomComponentsModule,
    TranslateModule,
    TranslationModule,
    LucideAngularModule,
  ],
  providers: [DynamicDialogConfig, DynamicDialogRef],
})
export class SharedModule {}
